import React from "react";
import Skeleton from "@material-ui/lab/Skeleton";
import { StyledTableRow, StyledTableCell } from "../Tables/Table";
function TableLoader(props) {
  // Pass number of columns to be spanned for skeleton
  const { numOfColumns } = props;
  return (
    <>
      {["1", "2", "3", "4"]?.map((ele) => (
        <StyledTableRow>
          <StyledTableCell colSpan={numOfColumns} scope="row">
            <Skeleton />
          </StyledTableCell>
        </StyledTableRow>
      ))}
    </>
  );
}

export default TableLoader;
